import type React from "react";
import Style from "./PageContainer.module.scss";

export const PageContainer: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
	return <div className={Style.container}>{children}</div>;
};
